import React, { VFCX } from 'react';
import styled from '@emotion/styled';

import { LayoutFixed, LayoutMain } from '.';

const Component: VFCX = ({ className }) => (
  <div {...{ className }}>
    <LayoutFixed />
    <LayoutMain />
  </div>
);

const StyledComponent = styled(Component)`
  background-color: var(--color-secondary-light);
  width: 100vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export default StyledComponent;
